export * from './app.component';
export * from './app.module';
export * from './app.routing';

export * from './modules';




// WEBPACK FOOTER //
// ./src/app/index.ts